import { render } from "./InformacionGeneralComponent.vue?vue&type=template&id=5327af5e&scoped=true"
import script from "./InformacionGeneralComponent.vue?vue&type=script&lang=js"
export * from "./InformacionGeneralComponent.vue?vue&type=script&lang=js"

import "./InformacionGeneralComponent.vue?vue&type=style&index=0&id=5327af5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5327af5e"]])

export default __exports__